// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".switchTabs_icon__2-fQz {\n  width: 30px !important;\n  height: 30px !important;\n  color: #464646;\n  margin: auto; }\n", ""]);
// Exports
exports.locals = {
	"icon": "switchTabs_icon__2-fQz"
};
module.exports = exports;
